import React from 'react';
import { styles } from './MiniCardGroup.css';
import { MiniCard, MiniCardProps } from '../MiniCard/MiniCard';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { GoToLink } from '../GoToLink/GoToLink';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';

export interface MiniCardGroupProps {
  heading?: string;
  cards: Array<MiniCardProps>;
  linkProps?: {
    href: string;
    label: string;
  };
  shouldFeatureFirstCard?: boolean;
}

export const MiniCardGroup = ({ heading, cards, linkProps, shouldFeatureFirstCard }: MiniCardGroupProps) => {
  const isDesktop = useBreakpoint('md', 'up');

  return (
    <div className={styles.container}>
      {heading ? (
        <div className={styles.headingContainer}>
          <CalloutFont as="h2" className={styles.heading}>
            {heading}
          </CalloutFont>
          {linkProps && isDesktop ? <GoToLink href={linkProps.href} label={linkProps.label} /> : null}
        </div>
      ) : null}
      <div className={styles.cardsContainer}>
        {cards.map((cardProps, index) => (
          <MiniCard key={index} size={shouldFeatureFirstCard && index === 0 ? 'large' : undefined} {...cardProps} />
        ))}
      </div>
      {linkProps && !isDesktop ? (
        <div className={styles.mobileLinkContainer}>
          <GoToLink href={linkProps.href} label={linkProps.label} />
        </div>
      ) : null}
    </div>
  );
};
